<template>
  <vx-tooltip :title="title"
              :text="text"
              position="top"
              class="rendering-failure-badge-anchor"
              delay="0.2s"
              @mouseenter.native="handleMouseEnter"
              @mouseleave.native="handleMouseLeave"
  >
    <span class="rendering-failure-badge">!</span>
  </vx-tooltip>
</template>

<script>
export default {
  name: 'RenderingFailureBadgeTooltip',

  emits: ['badge-enter', 'badge-leave'],

  props: {
    title: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    }
  },

  methods: {
    handleMouseEnter(event) {
      event.stopPropagation()
      this.$emit('badge-enter')
    },

    handleMouseLeave(event) {
      event.stopPropagation()
      this.$emit('badge-leave')
    }
  }
}
</script>

<style scoped>
.rendering-failure-badge-anchor {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 20;
  transform: translate(40%, -40%);
  pointer-events: auto;
}

.rendering-failure-badge {
  @apply flex items-center justify-center h-4 w-4 rounded-full bg-focus-error text-white text-xs font-bold leading-none cursor-default border-2 border-white shadow;
}
</style>
